module.exports = __webpack_public_path__ + "color.c7a33805ffda0d32bd2a.png";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/~/primeng/resources/images/color.png
// module id = ../../../../primeng/resources/images/color.png
// module chunks = 1